import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddEditProduct from "../components/AddEditProduct";

const EditProductPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Edit Product' />

                <AddEditProduct />

            </MasterLayout>
        </>
    );
};

export default EditProductPage;
